import React, { memo } from 'react';

import InstagramFeedGrid from 'react-ig-feed';
import 'react-ig-feed/dist/index.css';


import styled, { css } from 'styled-components';
import SectionHeadline from 'components/elements/SectionHeadline';

import PropTypes from 'prop-types';


const InstagramFeed = ({
  events,
  dispatch,
}) => {


  return (
    <Container>
      <StyledHeadline>Social Club</StyledHeadline>
      <InstagramFeedGrid token="IGQWRQN01WeEZAvckR5cXl6aXhVZAlR2SGtGNU5YZAUhPSHJUbTYwVFpHeTM2OW1vdy10aTBrUS1fYlgtbHpRT3Rubjd0WW9LLWEtMFprU3hiYXV6S2pXQnByZAEJPN1NaYmwzWXd6Qkk3U0NCMi15TnZAMTmlWeTBBRjgZD"  counter="6"/>
    </Container>
  )
};

InstagramFeed.propTypes = {
  mapIsOpen: PropTypes.bool
};

export default InstagramFeed;


const Container = styled.section`
  background-color: ${({ theme }) => theme.colors.Primary};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 3em 0;
  padding-bottom: 6em;
`;

const StyledHeadline = styled(SectionHeadline)`
  margin-bottom: 3em;
`;

